import React from 'react'

import { ReactComponent as CheckLoadingIcon } from './icons/check-loading.svg'
import { ReactComponent as FinalisingLoadingIcon } from './icons/finalising-loading.svg'
import { ReactComponent as InitialLoadingIcon } from './icons/initial-loading.svg'
import { ReactComponent as LowLoadingIcon } from './icons/low-loading.svg'
import { ReactComponent as MediumLoadingIcon } from './icons/medium-loading.svg'
import { ReactComponent as ReadyLoadingIcon } from './icons/ready-loading.svg'

import styles from './AnimatedLoading.module.css'

const AnimatedLoading = () => {
  return (
    <div className={styles.loadingContainer}>
      <InitialLoadingIcon className={`${styles.icon}`} />
      <LowLoadingIcon className={`${styles.icon}`} />
      <CheckLoadingIcon className={`${styles.icon}`} />
      <MediumLoadingIcon className={`${styles.icon}`} />
      <FinalisingLoadingIcon className={`${styles.icon}`} />
      <ReadyLoadingIcon className={`${styles.lastIcon}`} />
    </div>
  )
}

export default AnimatedLoading
